export class Tooltips {

    constructor(selector, tooltipId)
    {
        this.selector = selector;
        this.tooltipId = tooltipId;
        this.target = false;
        this.tooltip = false;
        this.title = false;
    }

    init()
    {
        const self = this;
        const targets = $(this.selector);
        targets.bind('mouseenter', this.openTooltip);
    };

    openTooltip()
    {
        this.target = $(this);
        this.tip = target.attr('title');
        this.tooltip = $('<div id="' + self.tooltipId + '"></div>');
        if (!this.tip || this.tip === '') {
            return false;
        }

        target.removeAttr('title');
        this.tooltip.css('opacity', 0)
            .html(this.tip)
            .appendTo('body')
            .show();
        this.target.bind('mouseleave', this.removeTooltip);
        this.tooltip.bind('click', this.removeTooltip);

    }

    removeTooltip()
    {
        this.tooltip.animate({top: '-=10', opacity: 0}, 50, function () {
            $(this).remove();
        });

        target.attr('title', tip);
    }

}

